import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled, { createGlobalStyle } from 'styled-components';
export var ModalContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  object-fit: contain;\n  z-index: 9;\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n  transition: opacity 200ms;\n\n  ", "\n\n  width: ", ";\n  height: ", ";\n\n  ", "\n  }\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return _extends({}, theme.modal.container);
}, function (_ref2) {
  var width = _ref2.width;
  return width || 'auto';
}, function (_ref3) {
  var height = _ref3.height;
  return height || 'auto';
}, function (_ref4) {
  var mobileFullScreen = _ref4.mobileFullScreen;
  return mobileFullScreen && "@media screen and (max-width: 768px) {\n          position: fixed;\n          width: 100%;\n          height: 100vh;\n          border-radius: 0;\n          top: 0;\n          left: auto;\n          transform: none;\n         }";
}, function (_ref5) {
  var isOpen = _ref5.isOpen;
  return isOpen ? 'opacity: 1;' : 'opacity: 0;';
});
export var Backdrop = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return _extends({}, theme.modal.backdrop);
});
export var CloseButton = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return _extends({}, theme.modal.closeButton);
});
export var ModalGlobalStyles = createGlobalStyle(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  .jui-modal {\n    position: relative;\n    z-index: 99999;\n  }\n"])));